import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

import { Link } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
	picturePreviewRoot: {
		position: 'relative',
	},
	crop: {
		height: '50px',
		width: '200px',
		overflow: 'hidden',
	},
	fill: {
		width: '200px',
		height: 'auto',
		marginTop: '-70px',
//		marginLeft: '-20px',
	},
	loading: {
		position: 'relative',
		height: '50px',
		width: '200px',
  },
	show: {
		display: 'show',
	},
	hide: {
		display: 'none',
	},
}));

export default function PicturePreview(props) {

	const classes = useStyles();

	const {
		imageId: id,
		imageUrl = 'https://firebasestorage.googleapis.com/v0/b/d992983fc.appspot.com/o/thumbnails%2FoS7yrZlnWwz2W97aJqfr?alt=media&token=85b2026c-eecc-4be9-9a24-3ec666227927',
	} = props;

	let [ loaded, setLoaded ] = React.useState(false);

	let handleLoaded = () => {
		console.log('Loaded image');
		setLoaded(true);
	}

	return (
	<div className={classes.picturePreviewRoot}>
		<Link	to={`/captures/${id}`}>

			<div
				className={`${classes.crop} ${loaded ? classes.show : classes.hide}`}
			>
    	  <img
					className={classes.fill}
    	    component="img"
					draggable="false"
    	    alt="Capture thumbnail"
					height="50"
    	    src={imageUrl}
					onLoad={handleLoaded}
    	  />
			</div>
			{!loaded && <div style={{height:'50px', width:'200px'}}>
				<CircularProgress color="primary" style={{position:'absolute', top:'25px', left:'50%', marginTop:'-20px', marginLeft:'-20px'}} size={40}/>
			</div>}

		</Link>
	</div>
	);
}
